module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_8019.cf2ca23b.png";